export default class Spark {
    constructor(client) {
        this.client = client
    }

    async all() {
        return await this.client.http().get("/v1/spark")
    }

    async get(id) {
        return await this.client.http().get(`/v1/spark/${id}`)
    }

    async update(id, data) {
        return await this.client.http().patch(`/v1/spark/${id}`, data)
    }

    async delete(id) {
        return await this.client.http().delete(`/v1/spark/${id}`)
    }

    async create(data) {
        return await this.client.http().post(`/v1/spark`, data)
    }

    async release(id, version) {
        return await this.client.http().put(`/v1/spark/release/${id}/${version}`)
    }

    async deploy(id, version) {
        return await this.client.http().put(`/v1/spark/deploy/${id}/${version}`)
    }

    async cancel(id) {
        return await this.client.http().put(`/v1/spark/cancel/${id}`)
    }

    async logs(id, options) {
        return await this.client.http().get(`/v1/spark/logs/${id}`, {
            params: options
        })
    }

    async tier() {
        return await this.client.http().get('/v1/spark/project/tier')
    }
}